import { normalizeObject, dataLayerPush, getSupporterID } from "../shared/utils";
export function myGivingHistoryDataVizView(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var chart_type = eventData['chart_type'];
    var chart_title = eventData['chart_title'];
    var supporter_id = getSupporterID();
    var dlEventData = normalizeObject({
        event: "data_viz_view",
        event_category: "giving_impact_viz",
        event_action: "".concat(chart_type, "_impression"),
        event_label: chart_title,
        card_title: chart_title,
        card_type: "data_viz",
        supporter_id: supporter_id
    });
    dataLayerPush(dlEventData);
}
export function myGivingHistoryDataVizInteraction(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var chart_type = eventData['chart_type'];
    var chart_title = eventData['chart_title'];
    var supporter_id = getSupporterID();
    var dlEventData = normalizeObject({
        event: "data_viz_interaction",
        event_category: "giving_impact_viz",
        event_action: "".concat(chart_type, "_interaction"),
        event_label: chart_title,
        card_title: chart_title,
        card_type: "data_viz",
        supporter_id: supporter_id
    });
    dataLayerPush(dlEventData);
}
export function myGivingHistoryDataVizClick(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var chart_type = eventData['chart_type'];
    var chart_title = eventData['chart_title'];
    var link_text = eventData['link_text'];
    var destination_url = eventData['destination_url'];
    var supporter_id = getSupporterID();
    var dlEventData = normalizeObject({
        event: "data_viz_click",
        event_category: "giving_impact_viz",
        event_action: "".concat(chart_type, "_click"),
        event_label: "".concat(chart_title, ":").concat(link_text, ":").concat(destination_url),
        card_title: chart_title,
        card_type: "data_viz",
        non_interaction: true,
        supporter_id: supporter_id
    });
    dataLayerPush(dlEventData);
}
